export default {
  path: 'refundstatus',
  component: () => import('@/views/dashboard/RefundStatus/Wrapper.vue'),
  children: [
    {
      path: '',
      name: 'refundstatus',
      component: () => import('@/views/dashboard/RefundStatus/Main.vue'),
    },
  ],
}
